<template>
  <div v-show="data.report.results.length > 0" class="table-responsive">
    <table class="table table-condensed table-striped standard-report frozen-table">
      <thead>
        <tr class="table-header header text-left">
          <th class="text-left">
            <span class>Center</span>
          </th>
          <th class="text-center">
            <span class>Checks</span>
          </th>
          <th class="text-center">
            <span class>Transactions</span>
          </th>
          <th class="text-right">
            <span class>Sales</span>
          </th>
          <th class="text-right">
            <span class>Discounts</span>
          </th>
          <th class="text-right">
            <span class>%</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="border-right"
          v-for="(v, vk) in data.report.results"
          :key="vk"
          v-show="data.report.results.length > 0"
        >
          <td class="text-center">{{ v.profitcentername }}</td>
          <td class="text-center">{{ v.checks | number('0,0') }}</td>
          <td class="text-center">{{ v.transactions | number('0,0')}}</td>
          <td v-if="!grossView" class="text-right">{{ v.net | currency }}</td>
          <td v-if="grossView" class="text-right">{{ v.gross | currency }}</td>
          <td class="text-right">{{ v.discounts | currency }}</td>
          <td class="text-right">
            <span
              v-if="grossView && v.gross > 0"
            >{{ v.gross / data.report.gross * 100 | number('00.0') }}</span>
            <span
              v-if="!grossView && v.net > 0"
            >{{ v.net / data.report.net * 100 | number('00.0') }}</span>
          </td>
        </tr>
        <tr class="border-right" v-show="!data.report.results.length > 0">
          <td class="text-center" colspan="8">NO DATA AVAILABLE</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-right">
          <td class="text-right">
            <strong>Totals:</strong>
          </td>
          <td class="text-center">
            <strong>{{ data.report.checks }}</strong>
          </td>
          <td class="text-center">
            <strong>{{ data.report.transactions }}</strong>
          </td>
          <td v-if="grossView" class="text-right">
            <strong>{{ data.report.gross | currency }}</strong>
          </td>
          <td v-if="!grossView" class="text-right">
            <strong>{{ data.report.net | currency }}</strong>
          </td>
          <td class="text-right">
            <strong>{{ data.report.discounts | currency }}</strong>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import DailyReportTab from './dailyReportTab'

export default {
  extends: DailyReportTab,
  components: {
  },
  data () {
    return {
      data: {
        loading: true,
        report: {
          results: []
        }
      },
      loadTimeout: null
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          this.data.loading = true
          DailyJournalReportService.getProfitCenterSummary(this.locationId, this.dailyDate)
            .then(res => {
              this.$updateloading(-1)
              this.data.loading = false
              this.data.report = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
